import { NgModule } from '@angular/core';
import { HourSelectorComponent } from './hour-selector.component';

@NgModule({
	imports: [],
	declarations: [HourSelectorComponent],
	exports: [HourSelectorComponent]
})
export class HourSelectorModule {}
